"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useAppScroll } from "@/components/providers/locomotive-scroll-provider";

/**
 * On route change, jump back to the top. Locomotive Scroll keeps its own scroll
 * position across client navigations, so without this a new page (e.g. switching
 * to /developers) would open wherever the previous page was scrolled to.
 */
export function ScrollToTop() {
  const pathname = usePathname();
  const { scrollTo } = useAppScroll();

  useEffect(() => {
    scrollTo(0, { immediate: true });
  }, [pathname, scrollTo]);

  return null;
}
